import { useEffect, useState } from "react";
import { Toaster } from "sonner";
import { Hero } from "../components/landing/Hero";
import { Movement } from "../components/landing/Movement";
import { DnaTimeline } from "../components/landing/DnaTimeline";
import { Leadership } from "../components/landing/Leadership";
import { Categories } from "../components/landing/Categories";
import { Technology } from "../components/landing/Technology";
import { Professionals } from "../components/landing/Professionals";
import { Legado } from "../components/landing/Legado";
import { Ecosystem } from "../components/landing/Ecosystem";
import { Manifesto } from "../components/landing/Manifesto";
import { RoleSelector } from "../components/landing/RoleSelector";
import { Footer } from "../components/landing/Footer";
import { LeadModal } from "../components/LeadModal";
import { InfoModal } from "../components/InfoModal";
import { verifyInvite } from "../lib/api";
import { AURACONECT_APP_URL } from "../data/content";

export default function LandingPage() {
  const [modal, setModal] = useState({ open: false, role: null });
  const [info, setInfo] = useState({ open: false, role: null });
  const [referral, setReferral] = useState(null);
  const [invite, setInvite] = useState(null);

  useEffect(() => {
    try {
      const params = new URLSearchParams(window.location.search);
      const ref = params.get("ref");
      if (ref) {
        localStorage.setItem("aura_ref", ref);
        setReferral(ref);
      } else {
        const saved = localStorage.getItem("aura_ref");
        if (saved) setReferral(saved);
      }
      const refAmb = params.get("refAmb");
      if (refAmb) localStorage.setItem("aura_ref_amb", refAmb);
      const ambCode = refAmb || localStorage.getItem("aura_ref_amb");
      if (ambCode) {
        verifyInvite(ambCode)
          .then((res) => {
            const d = res?.data;
            if (d?.ok && d?.referrer_type === "miss_aura") {
              setInvite({ code: d.code, name: d.referrer_name });
            }
          })
          .catch(() => {});
      }
    } catch {}
  }, []);

  const openRole = (role) => {
    if (role === "PROFESSIONAL") {
      window.open(AURACONECT_APP_URL, "_blank", "noopener,noreferrer");
      return;
    }
    if (role === "CLIENT") {
      setInfo({ open: true, role });
      return;
    }
    setModal({ open: true, role });
  };
  const scrollToRoles = () =>
    document.getElementById("seu-lugar")?.scrollIntoView({ behavior: "smooth" });

  return (
    <div data-testid="landing-page">
      <Hero onJoin={scrollToRoles} />
      <Movement />
      <DnaTimeline />
      <Leadership onOpenRole={openRole} />
      <Categories />
      <Technology />
      <Professionals onOpenRole={openRole} />
      <Legado />
      <Ecosystem />
      <Manifesto />
      <RoleSelector onOpenRole={openRole} />
      <Footer onJoin={scrollToRoles} />
      <LeadModal
        role={modal.role}
        open={modal.open}
        onOpenChange={(open) => setModal((m) => ({ ...m, open }))}
        referral={referral}
        invite={invite}
      />
      <InfoModal
        role={info.role}
        open={info.open}
        onOpenChange={(open) => setInfo((i) => ({ ...i, open }))}
      />
      <Toaster position="top-center" richColors />
    </div>
  );
}
